import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiDocumentQueryResponse,
  GetApiDocumentQueryParams,
  GetApiDocument401,
  GetApiDocument403,
} from "../../../types/GetApiDocument";

export function getGetApiDocumentUrl() {
  return `/api/Document` as const;
}

/**
 * {@link /api/Document}
 */
export async function getApiDocument(
  params?: GetApiDocumentQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiDocumentQueryResponse,
    ResponseErrorConfig<GetApiDocument401 | GetApiDocument403>,
    unknown
  >({
    method: "GET",
    url: getGetApiDocumentUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
